/**
 * Live School sur l'Accueil élève : le live EN COURS, sinon le prochain dans
 * les 7 jours (au-delà, l'info n'aide pas à décider quoi faire aujourd'hui).
 * PUR, testé.
 */

import {
  liveEventPhase,
  partitionLiveEvents,
  type LiveEvent,
} from '@/features/news-tabs/live-events';

export const NEXT_LIVE_HORIZON_MS = 7 * 86_400_000;

export function nextLiveForHome(
  events: { upcoming?: LiveEvent[]; past?: LiveEvent[]; server_time?: number } | null | undefined,
  now: number = Date.now(),
): { event: LiveEvent; live: boolean } | null {
  if (!events) return null;
  const serverTime = events.server_time ?? now;
  const { live, upcoming } = partitionLiveEvents(
    [...(events.upcoming ?? []), ...(events.past ?? [])],
    serverTime,
  );
  if (live[0]) return { event: live[0], live: true };
  const next = upcoming[0];
  if (!next) return null;
  if (new Date(next.starts_at).getTime() - serverTime > NEXT_LIVE_HORIZON_MS) return null;
  return { event: next, live: liveEventPhase(next, serverTime) === 'live' };
}
